import { upsertStyleTag, removeStyleTag } from "../../domStyles";

const ROOT = document.documentElement;

const CLASS_DARK_CONTRAST = "incluway-dark-contrast";
const STYLE_ID = "incluway-dark-contrast-style";
const EXCLUDE = "#incluway-widget-root";

export function enableDarkContrast() {
  ROOT.classList.remove("incluway-light-contrast", "incluway-high-contrast");
  ROOT.classList.add(CLASS_DARK_CONTRAST);

  upsertStyleTag(
    STYLE_ID,
    `
html.${CLASS_DARK_CONTRAST} body {
  background: #0b0f19 !important;
}

/* Borders */
html.${CLASS_DARK_CONTRAST} *:not(${EXCLUDE}):not(${EXCLUDE} *) {
  border-color: rgba(232, 238, 252, 0.22) !important;
}

/* Text */
html.${CLASS_DARK_CONTRAST} :is(
  p, span, li, td, th, label, small,
  strong, em, b, i, div
):not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #e8eefc !important;
}

/* Headings */
html.${CLASS_DARK_CONTRAST} :is(h1,h2,h3,h4,h5,h6):not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #ffffff !important;
  text-shadow: 0 1px 0 rgba(0,0,0,0.35) !important;
}

/* General surfaces */
html.${CLASS_DARK_CONTRAST} body :is(
  main, section, article, aside, header, footer, nav,
  div, form, fieldset, table, thead, tbody, tfoot, tr, td, th,
  ul, ol, li, blockquote,
  span, a, button, label, summary
):not(${EXCLUDE}):not(${EXCLUDE} *) {
  background-color: rgba(255,255,255,0.03) !important;
}

/* Inputs / controls */
html.${CLASS_DARK_CONTRAST} :is(input, textarea, select, button):not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: rgba(255,255,255,0.06) !important;
  color: #e8eefc !important;
  border: 1px solid rgba(232, 238, 252, 0.28) !important;
  box-shadow: none !important;
}

html.${CLASS_DARK_CONTRAST} :is(input, textarea, select):not(${EXCLUDE}):not(${EXCLUDE} *)::placeholder {
  color: rgba(232, 238, 252, 0.55) !important;
}

/* Links */
html.${CLASS_DARK_CONTRAST} a:not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #7db7ff !important;
  text-decoration: underline !important;
  text-underline-offset: 3px !important;
}

html.${CLASS_DARK_CONTRAST} a:visited:not(${EXCLUDE}):not(${EXCLUDE} *) {
  color: #b39bff !important;
}

/* Focus */
html.${CLASS_DARK_CONTRAST} :is(a,button,input,textarea,select,[tabindex]):focus-visible:not(${EXCLUDE}):not(${EXCLUDE} *) {
  outline: 3px solid #7db7ff !important;
  outline-offset: 3px !important;
  border-radius: 6px !important;
}

/* Tables */
html.${CLASS_DARK_CONTRAST} table:not(${EXCLUDE}):not(${EXCLUDE} *) {
  border-collapse: collapse !important;
}

html.${CLASS_DARK_CONTRAST} th:not(${EXCLUDE}):not(${EXCLUDE} *),
html.${CLASS_DARK_CONTRAST} td:not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: rgba(255,255,255,0.04) !important;
}

html.${CLASS_DARK_CONTRAST} tr:nth-child(even) td:not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: rgba(255,255,255,0.02) !important;
}

/* Code */
html.${CLASS_DARK_CONTRAST} :is(code,pre):not(${EXCLUDE}):not(${EXCLUDE} *) {
  background: rgba(255,255,255,0.06) !important;
  color: #e8eefc !important;
  border: 1px solid rgba(232, 238, 252, 0.20) !important;
}

/* Blockquotes */
html.${CLASS_DARK_CONTRAST} blockquote:not(${EXCLUDE}):not(${EXCLUDE} *) {
  border-left: 4px solid rgba(125,183,255,0.65) !important;
  padding-left: 12px !important;
  color: rgba(232, 238, 252, 0.92) !important;
}

/* Media */
html.${CLASS_DARK_CONTRAST} :is(img, video, picture, svg, canvas):not(${EXCLUDE}):not(${EXCLUDE} *) {
  filter: none !important;
  background: transparent !important;
}

/* Widget host exclusion */
html.${CLASS_DARK_CONTRAST} ${EXCLUDE} {
  background: initial !important;
  color: initial !important;
  border-color: initial !important;
  filter: none !important;
}
`.trim(),
  );
}

export function disableDarkContrast() {
  ROOT.classList.remove(CLASS_DARK_CONTRAST);
  removeStyleTag(STYLE_ID);
}
